/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import ReactDom from 'react-dom';
import available from '/client/src/utils/DOM_available';

import './Modal.scss';

type PropsType = {
  opened: boolean,
  onClose: () => void,
  children: null | React.Node,
  fullScreen?: boolean,
  top0?: boolean,
  ignoreOutsideClick?: boolean,
  overflow?: string,
  isScrollable?: boolean,
  altView?: boolean,
  isSystem?: boolean
};

type StateType = {
  canUseDom: boolean
};

const document = available<{ body?: HTMLBodyElement }>('document', { body: null });

class Modal extends React.Component<PropsType, StateType> {
  wrapper = React.createRef<HTMLDevElement>(null);

  state: StateType = {
    canUseDom: false,
    isOpen: false
  };

  componentDidMount = () => {
    this.setState({
      canUseDom: true
    });
  };

  UNSAFE_componentWillMount = () => {
    const that = this;

    setTimeout(() => {
      that.setState({ isOpen : true });
    }, 500);
  }

  handleClick = (e: SyntheticEvent<HTMLDivElement>) => {
    if (e.target === this.wrapper.current && !this.props.ignoreOutsideClick) {
      this.props.onClose(e);
    }
  };

  render = (): React.Node => this.state.canUseDom && document.body ? ReactDom.createPortal(
    <div
      // eslint-disable-next-line
      className={`
        Modal__wrapper${this.props.opened && this.state.isOpen ? ' Modal__wrapper--opened' : ''}
        ${this.props.isScrollable ? ' Modal__wrapper--scrollable' : ''}
        ${this.props.altView ? ' Modal__wrapper--altView' : ''}
        ${this.props.isSystem ? ' Modal__wrapper--system' : ''}
      `}
      onClick={this.handleClick}
      ref={this.wrapper}
    >
      <div
        className={`Modal__inner ${this.props.fullScreen ? 'Modal__inner-fullScreen' : ''}`}
        data-top-position={`${this.props.top0 ? 'top0' : 'auto'}`}
        style={{
          overflow: this.props.overflow ? this.props.overflow : 'hidden'
        }}
        onClick={this.handleClick}
      >
        {this.props.children}
      </div>
    </div>
  , document.body) : null;
}

export default Modal;
